/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated TypeScript interfaces from Swagger specification
* Do not edit this file manually
*/
import { HttpContext, HttpHeaders } from "@angular/common/http";
export interface UploadAvatarRequest {
    avatar: Blob;
}

export interface UpdateProfileRequest {
    firstName?: string | null;
    lastName?: string | null;
    localeIsoCode: string;
}

export interface UpdatePermissionsRequest {
    permissions: Array<PermissionId>;
}

export enum PermissionId {
    CanAccessFinances = "CanAccessFinances",
    CanAccessPeppol = "CanAccessPeppol",
    CanManageProduct = "CanManageProduct",
    CanManageLicenceServer = "CanManageLicenceServer",
    CanManageCustomerProducts = "CanManageCustomerProducts",
    CanValidTimesheet = "CanValidTimesheet",
    CanManagePermissions = "CanManagePermissions",
    CanAccessDocument = "CanAccessDocument",
    CanAccessTimesheet = "CanAccessTimesheet",
    CanAccessSettings = "CanAccessSettings",
    CanAccessTodo = "CanAccessTodo",
    CanManageUser = "CanManageUser"
}

export interface GetUsersResponse {
    users: Array<UserSelect>;
}

export interface UserSelect {
    id: number;
    fullName: string;
    email: string;
    initials: string;
    avatarUrl?: string | null;
}

export type GetUserAvatarRequest = Record<string, unknown>;

export interface GetPermissionsResponse {
    permissions: Array<PermissionId>;
}

export type GetPermissionsRequest = Record<string, unknown>;

export interface GetCurrentUserResponse {
    id: number;
    fullName: string;
    firstName?: string | null;
    lastName?: string | null;
    initials: string;
    localeIsoCode?: string | null;
    legalEntityId: number;
    avatarUrl?: string | null;
    permissionIds: Array<PermissionId>;
}

export type DeleteUserRequest = Record<string, unknown>;

export interface CreateUserResponse {
    id: number;
}

export interface CreateUserRequest {
    email: string;
    password: string;
    firstName?: string | null;
    lastName?: string | null;
    legalEntityId: number;
    localeIsoCode: string;
}

export interface GetUnitOfMeasureSelectResponse {
    unitsOfMeasure: Array<UnitOfMeasureSelect>;
}

export interface UnitOfMeasureSelect {
    code: UnitOfMeasureCode;
    description: string;
}

export enum UnitOfMeasureCode {
    C62 = "C62",
    HUR = "HUR",
    DAY = "DAY",
    MON = "MON"
}

export interface UploadTodoDocumentResponse {
    id: number;
    name: string;
}

export interface UploadTodoDocumentRequest {
    file: Blob;
}

export interface UpdateTodoRequest {
    title: string;
    description?: string | null;
    assignedToIds?: Array<number>;
    dueDate?: Date | null;
    concernId?: number | null;
    priorityName: TodoPriorityId;
    statusId: number;
    completion: TodoCompletion;
    estimatedTimeInDays?: number | null;
    children: Array<ChildTodoEdition>;
    isPrivate: boolean;
}

export enum TodoPriorityId {
    UNDEFINED = "UNDEFINED",
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH"
}

export enum TodoCompletion {
    PENDING = "PENDING",
    DONE = "DONE"
}

export type ChildTodoEdition = ChildTodoCreation & { id?: number };

export interface ChildTodoCreation {
    title: string;
    dueDate?: Date | null;
    assignedToId?: number | null;
    completion: TodoCompletion;
}

export interface GetTodosResponse {
    todos: Array<TodoSummary>;
}

export interface TodoSummary {
    id: number;
    title?: string | null;
    description?: string | null;
    createdAt: Date;
    createdBy?: UserSelect;
    assignees: Array<UserSelect>;
    state: TodoState;
    priority: TodoPrioritySelect;
    status: TodoStatusSummary;
    completion: TodoCompletion;
    dueDate?: Date | null;
    orderNum: number;
    childCount: number;
    totalDurationInSeconds: number;
    children: Array<TodoSummary>;
    concern?: PartySelect;
    isPrivate: boolean;
    estimatedTimeInDays?: number | null;
    parentId?: number | null;
}

export enum TodoState {
    ACTIVE = "ACTIVE",
    ARCHIVED = "ARCHIVED"
}

export interface TodoPrioritySelect {
    id: TodoPriorityId;
    name: string;
    color: string;
    orderNum: number;
}

export interface TodoStatusSummary {
    id: number;
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
    mustArchive: boolean;
    orderNum: number;
    isDefault: boolean;
}

export interface PartySelect {
    id: number;
    fullName: string;
    email?: string | null;
    type: PartyType;
    isoLocale?: string | null;
}

export enum PartyType {
    Contact = "Contact",
    Company = "Company",
    User = "User"
}

export type TodoFilter = Record<string, unknown>;

export interface GetTodoByIdResponse {
    todo: TodoDetails;
}

export interface TodoDetails {
    id: number;
    title: string;
    description?: string | null;
    createdAt: Date;
    createdBy?: UserSelect;
    isPrivate: boolean;
    assignees: Array<UserSelect>;
    state: TodoState;
    priority: TodoPrioritySelect;
    status: TodoStatusSummary;
    completion: TodoCompletion;
    completedAt?: Date | null;
    dueDate?: Date | null;
    orderNum: number;
    childCount: number;
    children: Array<TodoDetails>;
    documents: Array<DocumentSummary>;
    concern?: PartySelect;
    estimatedTimeInDays?: number | null;
    parentId?: number | null;
}

export interface DocumentSummary {
    id: number;
    name: string;
    folderId?: number | null;
    createdAt: Date;
    createdBy?: UserSelect;
}

export type GetTodoByIdRequest = Record<string, unknown>;
export type DeleteTodoRequest = Record<string, unknown>;
export type DeleteTodoDocumentRequest = Record<string, unknown>;

export interface CreateTodoResponse {
    id: number;
}

export interface CreateTodoRequest {
    title: string;
    description?: string | null;
    assignedToIds: Array<number>;
    dueDate?: Date | null;
    concernId?: number | null;
    priorityName: TodoPriorityId;
    statusId: number;
    isPrivate: boolean;
    estimatedTimeInDays?: number | null;
    children: Array<ChildTodoCreation>;
    completion: TodoCompletion;
}

export interface ChangeTodoStatusRequest {
    statusId: number;
    orderNum: number;
}

export interface ChangeTodoCompletionRequest {
    completion: TodoCompletion;
}

export interface UpdateTodoStatusRequest {
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
    mustArchive: boolean;
    isDefault: boolean;
    orderNum: number;
}

export interface ReorderTodoStatusesRequest {
    statusId: number;
    newOrderNumber: number;
}

export interface GetTodoStatusSelectResponse {
    todoStatuses: Array<TodoStatusSelect>;
}

export interface TodoStatusSelect {
    id: number;
    name: string;
    color?: string | null;
    mustArchive: boolean;
    orderNum: number;
    isDefault: boolean;
}

export interface GetTodoStatusesResponse {
    todoStatuses: Array<TodoStatusSummary>;
}

export interface GetTodoStatusByIdResponse {
    todoStatus: TodoStatusSummary;
}

export type GetTodoStatusByIdRequest = Record<string, unknown>;
export type DeleteTodoStatusRequest = Record<string, unknown>;

export interface CreateTodoStatusResponse {
    id: number;
}

export interface CreateTodoStatusRequest {
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
    mustArchive: boolean;
    orderNum: number;
    isDefault: boolean;
}

export interface GetTodoPrioritiesResponse {
    todoPriorities: Array<TodoPrioritySelect>;
}

export interface UpdateTimesheetTypeRequest {
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
    productId?: number | null;
    hasTravelExpenses: boolean;
}

export interface GetTimesheetTypesResponse {
    timesheetTypes: Array<TimesheetTypeSummary>;
}

export interface TimesheetTypeSummary {
    id: number;
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
    productId?: number | null;
    hasTravelExpenses: boolean;
}

export interface GetTimesheetTypeSelectResponse {
    timesheetTypes: Array<TimesheetTypeSelect>;
}

export interface TimesheetTypeSelect {
    id: number;
    name: string;
    hasTravelExpenses: boolean;
}

export interface GetTimesheetTypeByIdResponse {
    timesheetType: TimesheetTypeSummary;
}

export type GetTimesheetTypeByIdRequest = Record<string, unknown>;
export type DeleteTimesheetTypeRequest = Record<string, unknown>;

export interface CreateTimesheetTypeResponse {
    id: number;
}

export interface CreateTimesheetTypeRequest {
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
    productId?: number | null;
    hourlyRate?: number | null;
    hasTravelExpenses: boolean;
}

export interface UpdateTimesheetRequest {
    subject?: string | null;
    concernedPartyId?: number | null;
    startTime: Date;
    endTime: Date;
    date: Date;
    description?: string | null;
    billingDescription?: string | null;
    mileage?: number | null;
    travelExpensesAmount?: number | null;
    todoId?: number | null;
    timesheetTypeId: number;
    statusId?: number | null;
    isBillable: boolean;
    billableDurationInSeconds: number;
    productIds: Array<number>;
    activityTypeIds: Array<number>;
}

export interface UpdateTimesheetStateRequest {
    billingTimesheetState: BillingTimesheetState;
}

export enum BillingTimesheetState {
    DRAFT = "DRAFT",
    VALID = "VALID",
    LINKEDTOINVOICE = "LINKED_TO_INVOICE",
    BILLED = "BILLED"
}

export interface GetTravelDistanceResponse {
    distanceInKm: number;
    mapUrl: string;
}

export type GetTravelDistanceRequest = Record<string, unknown>;

export interface GetTimesheetsResponse {
    timesheets: Array<TimesheetSummary>;
}

export interface TimesheetSummary {
    id: number;
    subject?: string | null;
    startTime: Date;
    endTime: Date;
    date: Date;
    durationInSeconds: number;
    isBillable: boolean;
    billableDurationInSeconds: number;
    travelExpensesAmount?: number | null;
    billingTimesheetState: BillingTimesheetState;
    timesheetType: TimesheetTypeSelect;
    status?: TimesheetStatusSelect;
    createdBy?: UserSelect;
    concern?: PartySelect;
    activityTypes: Array<ActivityTypeSelect>;
}

export interface TimesheetStatusSelect {
    id: number;
    name?: string | null;
    color?: string | null;
}

export interface ActivityTypeSelect {
    id: number;
    name: string;
}

export type GetTimesheetsRequest = Record<string, unknown>;

export interface TimesheetDetail {
    id: number;
    subject?: string | null;
    createdBy: UserSelect;
    concern?: PartySelect;
    startTime: Date;
    endTime: Date;
    date: Date;
    durationInSeconds: number;
    isBillable: boolean;
    billableDurationInSeconds: number;
    estimatedTimeInDays?: number | null;
    description?: string | null;
    billingDescription?: string | null;
    mileage?: number | null;
    travelExpensesAmount?: number | null;
    timesheetType: TimesheetTypeSelect;
    todo: TodoSelect;
    status?: TimesheetStatusSummary;
    activityTypes: Array<ActivityTypeSelect>;
}

export interface TodoSelect {
    id: number;
    title: string;
}

export interface TimesheetStatusSummary {
    id: number;
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
}

export type GetTimesheetByIdRequest = Record<string, unknown>;

export interface GetTimesheetDocumentsResponse {
    documents: Array<DocumentSummary>;
}

export type GetTimesheetDocumentsRequest = Record<string, unknown>;
export type DeleteTimesheetRequest = Record<string, unknown>;
export type DeleteTimesheetDocumentRequest = Record<string, unknown>;

export interface CreateTimesheetResponse {
    id: number;
}

export interface CreateTimesheetRequest {
    subject?: string | null;
    concernedPartyId?: number | null;
    date: Date;
    startTime: Date;
    endTime: Date;
    description?: string | null;
    billingDescription?: string | null;
    mileage?: number | null;
    travelExpensesAmount?: number | null;
    todoId?: number | null;
    timesheetTypeId: number;
    statusId?: number | null;
    isBillable: boolean;
    billableDurationInSeconds: number;
    productIds: Array<number>;
    activityTypeIds: Array<number>;
}

export interface AttachTimesheetDocumentResponse {
    id: number;
}

export interface AttachTimesheetDocumentRequest {
    file: Blob;
}

export interface UpdateTimesheetStatusRequest {
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
}

export interface GetTimesheetStatusSelectResponse {
    timesheetStatuses: Array<TimesheetStatusSelect>;
}

export interface GetTimesheetStatusesResponse {
    timesheetStatuses: Array<TimesheetStatusSummary>;
}

export interface GetTimesheetStatusByIdResponse {
    timesheetStatus: TimesheetStatusSummary;
}

export type GetTimesheetStatusByIdRequest = Record<string, unknown>;
export type DeleteTimesheetStatusRequest = Record<string, unknown>;

export interface CreateTimesheetStatusResponse {
    id: number;
}

export interface CreateTimesheetStatusRequest {
    nameFr?: string | null;
    nameNl?: string | null;
    nameEn?: string | null;
    color?: string | null;
}

export interface UpdateTaxRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
    rate: number;
    peppolCode: string;
    isDefault: boolean;
    deductibleVatPercentage: number;
    accountingCode: string;
    accountingAccountId: number;
    accountingCode2?: string | null;
    accountingAccount2Id?: number | null;
}

export interface GetTaxSelectResponse {
    taxes: Array<TaxSelect>;
}

export interface TaxSelect {
    id: number;
    name: string;
    rate: number;
    peppolCode: string;
}

export interface GetTaxesResponse {
    taxes: Array<TaxSummary>;
}

export interface TaxSummary {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    rate: number;
    isDefault: boolean;
    peppolCode: string;
    deductibleVatPercentage: number;
    accountingCode?: string | null;
    accountingAccountId?: number | null;
    accountingAccountName: string;
    accountingCode2?: string | null;
    accountingAccount2Id?: number | null;
    accountingAccount2Name: string;
}

export type GetTaxesRequest = Record<string, unknown>;

export interface GetTaxByIdResponse {
    tax: TaxDetails;
}

export interface TaxDetails {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    rate: number;
    peppolCode: string;
    isDefault: boolean;
    deductibleVatPercentage: number;
    accountingCode?: string | null;
    accountingAccountId?: number | null;
    accountingCode2?: string | null;
    accountingAccount2Id?: number | null;
}

export type GetTaxByIdRequest = Record<string, unknown>;
export type DeleteTaxRequest = Record<string, unknown>;

export interface CreateTaxResponse {
    id: number;
}

export interface CreateTaxRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
    rate: number;
    peppolCode: string;
    isDefault: boolean;
    deductibleVatPercentage: number;
    accountingCode?: string | null;
    accountingAccountId?: number | null;
    accountingCode2?: string | null;
    accountingAccount2Id?: number | null;
}

export interface UpdateProductRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
    descriptionFr?: string | null;
    descriptionEn?: string | null;
    descriptionNl?: string | null;
    frequency?: ProductFrequency;
    licencePlanId?: number | null;
    featureId?: number | null;
    pluginId?: number | null;
    productType: ProductType;
    unitOfMeasureCode: UnitOfMeasureCode;
    legalEntityProducts: Array<LegalEntityProductInput>;
    pricePeriods: Array<PricePeriodInput>;
}

export enum ProductFrequency {
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY"
}

export enum ProductType {
    PLUGIN = "PLUGIN",
    LICENCE = "LICENCE",
    MAINTENANCECONTRACT = "MAINTENANCE_CONTRACT",
    FEATURE = "FEATURE",
    TIMESHEET = "TIMESHEET",
    OTHER = "OTHER",
    MODULE = "MODULE"
}

export interface LegalEntityProductInput {
    legalEntityId: number;
    accountingAccountId: number;
}

export interface PricePeriodInput {
    startDate: Date;
    endDate?: Date | null;
    price: number;
}

export interface GetProductsResponse {
    products: Array<ProductSummary>;
}

export interface ProductSummary {
    id: number;
    type: ProductType;
    nameFr: string;
    nameEn: string;
    nameNl: string;
}

export type ProductFilter = Record<string, unknown>;

export interface GetProductSelectResponse {
    products: Array<ProductSelect>;
}

export interface ProductSelect {
    id: number;
    name: string;
    productType: ProductType;
    frequency?: ProductFrequency;
    featureId?: number | null;
}

export interface GetProductByIdResponse {
    product: ProductDetails;
}

export interface ProductDetails {
    id: number;
    type: ProductType;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    descriptionFr?: string | null;
    descriptionEn?: string | null;
    descriptionNl?: string | null;
    frequency?: ProductFrequency;
    licencePlanId?: number | null;
    featureId?: number | null;
    pluginId?: number | null;
    unitOfMeasureCode: UnitOfMeasureCode;
    createdAt: Date;
    createdById?: number | null;
    pricePeriods: Array<PricePeriodSummary>;
    legalEntityProducts: Array<LegalEntityProductSummary>;
    timesheetType?: TimesheetTypeSelect;
}

export interface PricePeriodSummary {
    id: number;
    startDate: Date;
    endDate?: Date | null;
    price: number;
}

export interface LegalEntityProductSummary {
    id: number;
    legalEntityId: number;
    legalEntityName: string;
    accountingAccountId: number;
    accountingAccountName: string;
    accountingAccount: string;
}

export type GetProductByIdRequest = Record<string, unknown>;
export type DeleteProductRequest = Record<string, unknown>;

export interface CreateProductResponse {
    id: number;
}

export interface CreateProductRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
    descriptionFr?: string | null;
    descriptionEn?: string | null;
    descriptionNl?: string | null;
    frequency?: ProductFrequency;
    licencePlanId?: number | null;
    featureId?: number | null;
    pluginId?: number | null;
    productType: ProductType;
    unitOfMeasureCode: UnitOfMeasureCode;
    legalEntityProducts: Array<LegalEntityProductInput>;
    pricePeriods: Array<PricePeriodInput>;
}

export interface ApplyPriceCoefficientRequest {
    productIds: Array<number>;
    coefficient: number;
    startDate: Date;
    endDate?: Date | null;
}

export interface UpdatePluginRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
}

export interface GetPluginsResponse {
    plugins: Array<PluginSummary>;
}

export interface PluginSummary {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    guid?: string | null;
}

export type GetPluginsRequest = Record<string, unknown>;

export interface GetPluginSelectResponse {
    plugins: Array<PluginSelect>;
}

export interface PluginSelect {
    id: number;
    name: string;
}

export interface GetPluginByIdResponse {
    plugin: PluginDetails;
}

export interface PluginDetails {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    guid?: string | null;
}

export type GetPluginByIdRequest = Record<string, unknown>;
export type DeletePluginRequest = Record<string, unknown>;

export interface CreatePluginResponse {
    id: number;
}

export interface CreatePluginRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
}

export interface GetPermissionCatalogResponse {
    permissions: Array<PermissionId>;
}

export interface GetPermissionAssignmentsResponse {
    users: Array<PermissionAssignment>;
}

export interface PermissionAssignment {
    userAccountId: string;
    fullName: string;
    permissions: Array<PermissionId>;
    isCurrentUser: boolean;
}

export interface GetPaymentModesResponse {
    paymentModes: Array<PaymentModeSummary>;
}

export interface PaymentModeSummary {
    id: number;
    method: PaymentMethod;
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
}

export enum PaymentMethod {
    Cash = "Cash",
    Cheque = "Cheque",
    Debit = "Debit",
    DirectDebit = "DirectDebit",
    BankTransfer = "BankTransfer",
    BankCheque = "BankCheque"
}

export type GetPaymentModesRequest = Record<string, unknown>;

export interface GetPaymentModeSelectResponse {
    paymentModes: Array<PaymentModeSelect>;
}

export interface PaymentModeSelect {
    id: number;
    name: string;
}

export interface GetPartiesResponse {
    parties: Array<PartySelect>;
}

export type PartyFilter = Record<string, unknown>;
export type MarkNotificationAsReadRequest = Record<string, unknown>;

export interface GetNotificationsResponse {
    notifications: Array<NotificationSummary>;
}

export interface NotificationSummary {
    id: number;
    description: string;
    type: NotificationType;
    isRead: boolean;
    createdAt: Date;
    objectType?: string | null;
    objectId?: number | null;
    authorFullName?: string | null;
}

export enum NotificationType {
    TODOASSIGNEDCHANGED = "TODO_ASSIGNED_CHANGED",
    TODOMENTIONED = "TODO_MENTIONED",
    REMINDTODO = "REMIND_TODO"
}

export type DeleteNotificationRequest = Record<string, unknown>;

export interface UpdateMailTemplateRequest {
    name: string;
    object: string;
    body: string;
    localIsoCode: string;
}

export interface GetMailTemplatesResponse {
    mailTemplates: Array<MailTemplateSummary>;
}

export interface MailTemplateSummary {
    id: number;
    name: string;
    object: string;
    localIsoCode: string;
}

export type GetMailTemplatesRequest = Record<string, unknown>;

export interface GetMailTemplateByIdResponse {
    mailTemplate: MailTemplateDetails;
}

export interface MailTemplateDetails {
    id: number;
    name: string;
    object: string;
    body: string;
    localIsoCode: string;
}

export type GetMailTemplateByIdRequest = Record<string, unknown>;
export type DeleteMailTemplateRequest = Record<string, unknown>;

export interface CreateMailTemplateResponse {
    id: number;
}

export interface CreateMailTemplateRequest {
    name: string;
    object: string;
    body: string;
    localIsoCode: string;
}

export type ResolveLogRequest = Record<string, unknown>;

export interface GetUnresolvedLogsResponse {
    logs: Array<LogSummary>;
}

export interface LogSummary {
    id: number;
    date: Date;
    level: LogLevel;
    message: string;
    customerId?: number | null;
    customerName?: string | null;
    invoiceId?: number | null;
}

export enum LogLevel {
    ERROR = "ERROR",
    WARNING = "WARNING"
}

export type DeleteLogRequest = Record<string, unknown>;

export interface UpdateLicenceServerRequest {
    name: string;
    customerProductIds: Array<number>;
}

export interface LicenceServerProduct {
    licences: Array<CustomerProductLicence>;
    plugins: Array<CustomerProductPlugin>;
}

export interface CustomerProductLicence {
    id: number;
    reference?: string | null;
    nameFr: string;
    nameNL: string;
    nameEn: string;
    startDate?: Date | null;
    endDate?: Date | null;
    isActive: boolean;
    features: Array<FeatureSummary>;
}

export interface FeatureSummary {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    guid?: string | null;
}

export interface CustomerProductPlugin {
    id: number;
    nameFr: string;
    nameNL: string;
    nameEn: string;
    startDate?: Date | null;
    endDate?: Date | null;
    isActive: boolean;
    guid?: string | null;
}

export interface GetLicenceServersByCustomerIdResponse {
    licenceServers: Array<LicenceServerSummary>;
}

export interface LicenceServerSummary {
    id: number;
    reference?: string | null;
    name: string;
    customerProductCount: number;
    createdAt: Date;
    createdBy?: UserSelect;
    updatedAt?: Date | null;
    updatedBy?: UserSelect;
    products: LicenceServerProduct;
}

export type GetLicenceServersByCustomerIdRequest = Record<string, unknown>;
export type GetLicenceServerProductsRequest = Record<string, unknown>;

export interface GenerateCredentialResponse {
    clientId: string;
    clientSecret: string;
}

export type GenerateCredentialRequest = Record<string, unknown>;
export type DeleteLicenceServerRequest = Record<string, unknown>;

export interface CreateLicenceServerResponse {
    id: number;
}

export interface CreateLicenceServerRequest {
    customerId: number;
    name: string;
    customerProductIds: Array<number>;
}

export interface UpdateLicencePlanRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
    descriptionFr?: string | null;
    descriptionEn?: string | null;
    descriptionNl?: string | null;
    includedFeatureCodes: Array<number>;
}

export interface GetLicencePlansResponse {
    licencePlans: Array<LicencePlanSummary>;
}

export interface LicencePlanSummary {
    id: number;
    code: LicencePlanCode;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    featureCount: number;
}

export enum LicencePlanCode {
    BASIC = "BASIC",
    PRO = "PRO",
    FULL = "FULL",
    EWBASIC = "EW_BASIC",
    EWPRO = "EW_PRO",
    EWFULL = "EW_FULL"
}

export interface GetLicencePlanSelectResponse {
    licencePlans: Array<LicencePlanSelect>;
}

export interface LicencePlanSelect {
    id: number;
    name: string;
}

export interface GetLicencePlanByIdResponse {
    licencePlan: LicencePlanDetails;
}

export interface LicencePlanDetails {
    id: number;
    code: LicencePlanCode;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    descriptionFr?: string | null;
    descriptionEn?: string | null;
    descriptionNl?: string | null;
    includedFeatureCodes: Array<number>;
}

export type GetLicencePlanByIdRequest = Record<string, unknown>;

export interface GetLegalEntitiesResponse {
    legalEntities: Array<LegalEntitySummary>;
}

export interface LegalEntitySummary {
    id: number;
    name: string;
    taxIdentifierNumber: string;
    email: string;
    phone: string;
}

export interface UpdateInvoiceRequest {
    invoiceDate: Date;
    customerId: number;
    legalEntityId: number;
    note?: string | null;
    localeIsoCode?: string | null;
    invoiceLines: Array<InvoiceLineEdition>;
}

export interface InvoiceLineEdition {
    id: number;
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    productId: number;
    timesheetIds?: Array<number>;
    taxId: number;
    customerProductBillingId?: number | null;
    billingPeriodStart?: Date | null;
    billingPeriodEnd?: Date | null;
    isTravelExpense?: boolean | null;
}

export interface SendInvoiceRequest {
    to: Array<string>;
    cc: Array<string>;
    bcc: Array<string>;
    object: string;
    content: string;
    isProForma: boolean;
    attachments?: Array<Blob>;
}

export interface RunDailyInvoicingResponse {
    failures: Array<DailyInvoicingFailure>;
}

export interface DailyInvoicingFailure {
    customerId: number;
    customerName: string;
    errorCode?: string | null;
}

export interface GetOutgoingInvoicesResponse {
    invoices: Array<InvoicePeppolSummary>;
}

export interface InvoicePeppolSummary {
    uuid?: string | null;
    direction?: string | null;
    format?: string | null;
    number?: string | null;
    date?: string | null;
    sender?: PartyName;
    recipient?: PartyName;
    createdAt?: string | null;
    downloaded: boolean;
    peppolMessage?: PeppolMessageDto;
}

export interface PartyName {
    identifier: string;
    name: string;
}

export interface PeppolMessageDto {
    uuid?: string | null;
    createdAt?: string | null;
    requestSentAt?: string | null;
    responseReceivedAt?: string | null;
    success: boolean;
    errorCode?: string | null;
    errorMessage?: string | null;
}

export type GetOutgoingInvoicesRequest = Record<string, unknown>;

export interface GetLastNumberedInvoiceDateResponse {
    lastNumberedDate?: Date | null;
}

export type GetLastNumberedInvoiceDateRequest = Record<string, unknown>;

export interface GetInvoicesResponse {
    invoices: Array<InvoiceSummary>;
}

export interface InvoiceSummary {
    id: number;
    date: Date;
    customerName: string;
    legalEntityName: string;
    number: string;
    amountWithoutTax: number;
    stateName: InvoiceStateId;
    invoiceType: InvoiceKind;
    directDebitExportedAt?: Date | null;
    accountingExportedAt?: Date | null;
}

export enum InvoiceStateId {
    DRAFT = "DRAFT",
    SENT = "SENT",
    PAID = "PAID",
    CREDITED = "CREDITED"
}

export enum InvoiceKind {
    STANDARD = "STANDARD",
    RECURRING = "RECURRING"
}

export type GetInvoicesRequest = Record<string, unknown>;
export type GetInvoicesPeppolFileRequest = Record<string, unknown>;
export type GetInvoicesAttachmentsRequest = Record<string, unknown>;
export type GetInvoicePdfRequest = Record<string, unknown>;

export interface GetInvoiceByIdResponse {
    invoice: InvoiceDetails;
}

export interface InvoiceDetails {
    id: number;
    invoiceDate: Date;
    customerId: number;
    legalEntityId: number;
    note?: string | null;
    localeIsoCode?: string | null;
    invoiceType: InvoiceKind;
    invoiceLines: Array<InvoiceLineEdition>;
}

export type GetInvoiceByIdRequest = Record<string, unknown>;

export interface GetInvoiceAccountingOperationsResponse {
    accountingOperations: Array<AccountingOperationDetails>;
}

export interface AccountingOperationDetails {
    id: number;
    name: string;
    credit: number;
    debit: number;
    accountingCode?: string | null;
    accountingAccountName?: string | null;
    accountingAccountNumber?: string | null;
}

export type GetInvoiceAccountingOperationsRequest = Record<string, unknown>;
export type GetIncomingInvoicesRequest = Record<string, unknown>;

export interface GetCustomerInvoicingPreviewResponse {
    lines: Array<InvoicingPreviewLine>;
}

export interface InvoicingPreviewLine {
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    amount: number;
    isTimesheet: boolean;
    isRecurring: boolean;
}

export type GetCustomerInvoicingPreviewRequest = Record<string, unknown>;
export type DeleteInvoiceRequest = Record<string, unknown>;

export interface CreateInvoiceResponse {
    id: number;
}

export interface CreateInvoiceRequest {
    invoiceDate: Date;
    customerId: number;
    note?: string | null;
    localeIsoCode?: string | null;
    legalEntityId: number;
    invoiceLines: Array<InvoiceLineCreation>;
}

export interface InvoiceLineCreation {
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    productId: number;
    timesheetIds?: Array<number>;
    taxId: number;
}

export interface UpdateFolderRequest {
    name: string;
    parentId?: number | null;
    orderNum: number;
    userIds: Array<number>;
}

export interface GetFoldersResponse {
    folders: Array<FolderSummary>;
}

export interface FolderSummary {
    id: number;
    name: string;
    orderNum: number;
    folderType: FolderType;
    parentId?: number | null;
    folders: Array<FolderSummary>;
    userAccess: Array<UserSelect>;
}

export enum FolderType {
    CUSTOM = "CUSTOM",
    TODO = "TODO",
    INVOICES = "INVOICES",
    CREDITNOTES = "CREDIT_NOTES",
    TIMESHEET = "TIMESHEET"
}

export type FolderFilter = Record<string, unknown>;

export interface GetFolderByIdResponse {
    folder: FolderDetails;
}

export interface FolderDetails {
    id: number;
    name: string;
    orderNum: number;
    parentId?: number | null;
    createdAt: Date;
    createdBy?: UserSelect;
}

export type GetFolderByIdRequest = Record<string, unknown>;
export type DeleteFolderRequest = Record<string, unknown>;

export interface CreateFolderResponse {
    id: number;
}

export interface CreateFolderRequest {
    name: string;
    parentId?: number | null;
    userIds: Array<number>;
}

export interface UpdateFeatureRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
}

export interface GetFeaturesResponse {
    features: Array<FeatureSummary>;
}

export type GetFeaturesRequest = Record<string, unknown>;

export interface GetFeatureSelectResponse {
    features: Array<FeatureSelect>;
}

export interface FeatureSelect {
    id: number;
    name: string;
}

export interface GetFeatureByIdResponse {
    feature: FeatureDetails;
}

export interface FeatureDetails {
    id: number;
    nameFr: string;
    nameEn: string;
    nameNl: string;
    guid?: string | null;
}

export type GetFeatureByIdRequest = Record<string, unknown>;
export type DeleteFeatureRequest = Record<string, unknown>;

export interface CreateFeatureResponse {
    id: number;
}

export interface CreateFeatureRequest {
    nameFr: string;
    nameEn: string;
    nameNl: string;
}

export interface UploadDocumentResponse {
    id: number;
}

export interface UploadDocumentRequest {
    folderId?: number | null;
    file: Blob;
}

export interface MoveDocumentFolderRequest {
    documentId: number;
    folderId: number;
}

export interface GetDocumentsResponse {
    documents: Array<DocumentSummary>;
}

export type GetDocumentsRequest = Record<string, unknown>;

export interface GetDocumentByIdResponse {
    document: DocumentDetails;
}

export interface DocumentDetails {
    id: number;
    name: string;
    folderId?: number | null;
    createdAt: Date;
    createdBy?: UserSelect;
}

export type GetDocumentByIdRequest = Record<string, unknown>;
export type DownloadDocumentRequest = Record<string, unknown>;
export type DeleteDocumentRequest = Record<string, unknown>;

export interface PreviewDirectDebitRequest {
    invoiceIds: Array<number>;
}

export interface ExportDirectDebitRequest {
    invoiceIds: Array<number>;
}

export interface GetDashboardTodoStatsResponse {
    stats: DashboardTodoStats;
}

export interface DashboardTodoStats {
    pendingCount: number;
    overdueCount: number;
    byPriority: Array<DashboardTodoByPriority>;
    urgentTodos: Array<DashboardUrgentTodo>;
}

export interface DashboardTodoByPriority {
    priority: TodoPriorityId;
    color?: string | null;
    orderNum: number;
    count: number;
}

export interface DashboardUrgentTodo {
    id: number;
    title?: string | null;
    dueDate?: Date | null;
    parentId?: number | null;
    parentTitle?: string | null;
    concernName?: string | null;
    priority?: TodoPriorityId;
    priorityColor?: string | null;
}

export interface GetDashboardTimesheetStatsResponse {
    stats: DashboardTimesheetStats;
}

export interface DashboardTimesheetStats {
    monthToDateSeconds: number;
    previousMonthToDateSeconds: number;
    weekSlices: Array<DashboardTimesheetSlice>;
    byType: Array<DashboardTimesheetByType>;
    byCustomer: Array<DashboardTimesheetByCustomer>;
}

export interface DashboardTimesheetSlice {
    index: number;
    currentMonthSeconds?: number | null;
    previousMonthSeconds: number;
    isCurrent: boolean;
}

export interface DashboardTimesheetByType {
    timesheetTypeId: number;
    name: string;
    currentMonthSeconds: number;
    previousMonthSeconds: number;
}

export interface DashboardTimesheetByCustomer {
    customerId?: number | null;
    name: string;
    seconds: number;
    types: Array<DashboardTimesheetCustomerTypeShare>;
}

export interface DashboardTimesheetCustomerTypeShare {
    timesheetTypeId: number;
    seconds: number;
}

export interface GetDashboardInvoicingStatsResponse {
    stats: DashboardInvoicingStats;
}

export interface DashboardInvoicingStats {
    draftAmount: number;
    draftCount: number;
    billedAmount: number;
}

export interface UpdateCustomerProductRequest {
    productId: number;
    startDate?: Date | null;
    endDate?: Date | null;
    quantity: number;
    price: number;
    mustIncludeInInvoicing: boolean;
    description?: string | null;
    isActive: boolean;
    features: Array<CustomerProductFeatureItem>;
}

export interface CustomerProductFeatureItem {
    productId: number;
    quantity: number;
    price: number;
    mustIncludeInInvoicing: boolean;
    description?: string | null;
}

export interface GetCustomerProductsByCustomerIdResponse {
    customerProducts: Array<CustomerProductSummary>;
}

export interface CustomerProductSummary {
    id: number;
    productId: number;
    productName: string;
    startDate?: Date | null;
    endDate?: Date | null;
    quantity: number;
    price: number;
    mustIncludeInInvoicing: boolean;
    description?: string | null;
    isActive: boolean;
    licenceServerId?: number | null;
    licenceServerName?: string | null;
    extraFeatures: Array<CustomerProductSummary>;
    createdAt: Date;
    createdBy?: UserSelect;
    updatedAt?: Date | null;
    updatedBy?: UserSelect;
}

export type GetCustomerProductsByCustomerIdRequest = Record<string, unknown>;

export interface GetCustomerProductHistoryTimelineResponse {
    history: Array<CustomerProductHistoryTimelineSummary>;
}

export interface CustomerProductHistoryTimelineSummary {
    id: number;
    customerId: number;
    customerName: string;
    customerType: PartyType;
    productName: string;
    parentProductName?: string | null;
    event: CustomerProductHistoryEvent;
    createdAt: Date;
    createdBy?: UserSelect;
    changes: Array<CustomerProductHistoryChangeSummary>;
}

export enum CustomerProductHistoryEvent {
    CREATED = "CREATED",
    UPDATED = "UPDATED",
    DELETED = "DELETED"
}

export interface CustomerProductHistoryChangeSummary {
    field: CustomerProductHistoryField;
    oldValue?: string | null;
    newValue?: string | null;
}

export enum CustomerProductHistoryField {
    PRODUCT = "PRODUCT",
    STARTDATE = "START_DATE",
    ENDDATE = "END_DATE",
    QUANTITY = "QUANTITY",
    PRICE = "PRICE",
    MUSTINCLUDEININVOICING = "MUST_INCLUDE_IN_INVOICING",
    DESCRIPTION = "DESCRIPTION",
    ISACTIVE = "IS_ACTIVE"
}

export type GetCustomerProductHistoryTimelineRequest = Record<string, unknown>;

export interface GetCustomerProductHistoryByCustomerIdResponse {
    history: Array<CustomerProductHistorySummary>;
}

export interface CustomerProductHistorySummary {
    id: number;
    customerProductId?: number | null;
    productName: string;
    parentProductName?: string | null;
    parentCustomerProductId?: number | null;
    event: CustomerProductHistoryEvent;
    createdAt: Date;
    createdBy?: UserSelect;
    changes: Array<CustomerProductHistoryChangeSummary>;
}

export type GetCustomerProductHistoryByCustomerIdRequest = Record<string, unknown>;

export interface GetCustomerProductBillingsByCustomerIdResponse {
    billings: Array<CustomerProductBillingSummary>;
}

export interface CustomerProductBillingSummary {
    id: number;
    productNameFr: string;
    productNameEn: string;
    productNameNl: string;
    periodStart?: Date | null;
    periodEnd?: Date | null;
    amount: number;
    invoiceId: number;
    invoiceNumber?: string | null;
    invoiceState: InvoiceStateId;
    createdAt: Date;
}

export type GetCustomerProductBillingsByCustomerIdRequest = Record<string, unknown>;
export type DeleteCustomerProductRequest = Record<string, unknown>;

export interface CreateCustomerProductResponse {
    id: number;
}

export interface CreateCustomerProductRequest {
    customerId: number;
    productId: number;
    startDate?: Date | null;
    endDate?: Date | null;
    quantity: number;
    price: number;
    mustIncludeInInvoicing: boolean;
    description?: string | null;
    features: Array<CustomerProductFeatureItem>;
}

export interface UpdateCreditNoteRequest {
    creditNoteDate: Date;
    customerId: number;
    legalEntityId: number;
    invoiceId?: number | null;
    lines: Array<CreditNoteLineEdition>;
}

export interface CreditNoteLineEdition {
    id?: number | null;
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    productId: number;
    taxId: number;
}

export interface SendCreditNoteRequest {
    to: Array<string>;
    cc: Array<string>;
    bcc: Array<string>;
    object: string;
    content: string;
    attachments?: Array<Blob>;
}

export interface GetOutgoingCreditNotesResponse {
    creditNotes: Array<CreditNotePeppolSummary>;
}

export interface CreditNotePeppolSummary {
    uuid?: string | null;
    direction?: string | null;
    format?: string | null;
    number?: string | null;
    date?: string | null;
    sender?: PartyName;
    recipient?: PartyName;
    createdAt?: string | null;
    downloaded: boolean;
    peppolMessage?: PeppolMessageDto;
}

export type GetOutgoingCreditNotesRequest = Record<string, unknown>;

export interface GetIncomingCreditNotesResponse {
    creditNotes: Array<CreditNotePeppolSummary>;
}

export type GetIncomingCreditNotesRequest = Record<string, unknown>;

export interface GetCreditNoteResponse {
    creditNotes: Array<CreditNoteSummary>;
}

export interface CreditNoteSummary {
    id: number;
    date: Date;
    customerName: string;
    legalEntityName: string;
    number?: string | null;
    amountWithoutTax: number;
    stateName: CreditNoteStateId;
    accountingExportedAt?: Date | null;
}

export enum CreditNoteStateId {
    DRAFT = "DRAFT",
    SENT = "SENT"
}

export type GetCreditNoteRequest = Record<string, unknown>;
export type GetCreditNotesPeppolFileRequest = Record<string, unknown>;
export type GetCreditNotesAttachmentsRequest = Record<string, unknown>;
export type GetCreditNotePdfRequest = Record<string, unknown>;

export interface GetCreditNoteByIdResponse {
    creditNote: CreditNoteDetails;
}

export interface CreditNoteDetails {
    id: number;
    date: Date;
    customerId: number;
    legalEntityId: number;
    invoiceId?: number | null;
    number?: string | null;
    stateName: CreditNoteStateId;
    lines: Array<CreditNoteLineDetails>;
}

export interface CreditNoteLineDetails {
    id: number;
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    productId: number;
    taxId: number;
    taxRate: number;
}

export type GetCreditNoteByIdRequest = Record<string, unknown>;

export interface GetCreditNoteAccountingOperationsResponse {
    accountingOperations: Array<AccountingOperationDetails>;
}

export type GetCreditNoteAccountingOperationsRequest = Record<string, unknown>;
export type DeleteCreditNoteRequest = Record<string, unknown>;

export interface CreateCreditNoteResponse {
    id: number;
}

export interface CreateCreditNoteRequest {
    creditNoteDate: Date;
    customerId: number;
    legalEntityId: number;
    invoiceId?: number | null;
    lines: Array<CreditNoteLineCreation>;
}

export interface CreditNoteLineCreation {
    label: string;
    description?: string | null;
    quantity: number;
    unitPrice: number;
    productId: number;
    taxId: number;
}

export interface SetCountryFavoriteRequest {
    isFavorite: boolean;
}

export interface GetCountrySelectResponse {
    countries: Array<CountrySelect>;
}

export interface CountrySelect {
    isoCode: string;
    name: string;
    vatZone: VatZone;
    isFavorite: boolean;
}

export enum VatZone {
    Domestic = "Domestic",
    IntraCommunity = "IntraCommunity",
    Export = "Export"
}

export interface GetCountryDetailsResponse {
    country: CountryDetails;
}

export interface CountryDetails {
    isoCode: string;
    name: string;
    vatZone: VatZone;
    isFavorite: boolean;
    isArchived: boolean;
}

export type GetCountryDetailsRequest = Record<string, unknown>;

export interface UpdateContactRequest {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    isActive: boolean;
    crmId?: number | null;
    isSameAddressForBillingAddress: boolean;
    address: Address;
    billingAddress: Address;
    note: string;
    accountingAccountName?: string | null;
    companyId?: number | null;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
}

export interface Address {
    street?: string | null;
    number?: string | null;
    postalCode?: string | null;
    city?: string | null;
    countryIsoCode: string;
}

export interface GetContactsResponse {
    contacts: Array<ContactSummary>;
}

export interface ContactSummary {
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    phone: string;
    companyId?: number | null;
    companyName?: string | null;
    isActive: boolean;
}

export type ContactFilter = Record<string, unknown>;

export enum CustomerState {
    IsActive = "IsActive",
    IsInactive = "IsInactive"
}

export interface GetContactByIdResponse {
    contact: ContactDetails;
}

export interface ContactDetails {
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    phone: string;
    isActive: boolean;
    crmId?: number | null;
    isSameAddressForBillingAddress: boolean;
    address?: Address;
    billingAddress?: Address;
    note?: string | null;
    accountingAccountName?: string | null;
    companyId?: number | null;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
}

export type GetContactByIdRequest = Record<string, unknown>;
export type DeleteContactRequest = Record<string, unknown>;

export interface CreateContactResponse {
    id: number;
}

export interface CreateContactRequest {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    isActive: boolean;
    crmId?: number | null;
    isSameAddressForBillingAddress: boolean;
    address: Address;
    billingAddress: Address;
    note: string;
    accountingAccountName?: string | null;
    companyId?: number | null;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
}

export interface UpdateCompanyRequest {
    name: string;
    vatNumber?: string;
    isActive: boolean;
    crmId?: number | null;
    isSameAddressForBillingAddress: boolean;
    address: Address;
    billingAddress?: Address;
    note: string;
    accountingAccountName?: string | null;
    webSite: string;
    email?: string | null;
    contactIds: Array<number>;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
    paymentModeId?: number | null;
    directDebit?: DirectDebitMandate;
}

export interface DirectDebitMandate {
    iban?: string | null;
    bic?: string | null;
    reference?: string | null;
    signedAt?: Date | null;
}

export interface GetCompanyByIdResponse {
    company: CompanyDetails;
}

export interface CompanyDetails {
    id: number;
    name: string;
    guid?: string | null;
    webSite?: string | null;
    taxIdentifierNumber?: string | null;
    isActive: boolean;
    crmId?: number | null;
    isSameAddressForBillingAddress: boolean;
    address?: Address;
    billingAddress?: Address;
    note?: string | null;
    accountingAccountName?: string | null;
    contacts: Array<ContactSelect>;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
    email: string;
    paymentModeId?: number | null;
    directDebit?: DirectDebitMandate;
}

export interface ContactSelect {
    id: number;
    fullName: string;
    email?: string | null;
}

export type GetCompanyByIdRequest = Record<string, unknown>;

export interface GetCompaniesResponse {
    companies: Array<CompanySummary>;
}

export interface CompanySummary {
    id: number;
    name: string;
    taxIdentifierNumber: string;
    address: string;
    isActive: boolean;
}

export type CompanyFilter = Record<string, unknown>;
export type DeleteCompanyRequest = Record<string, unknown>;

export interface CreateCompanyResponse {
    id: number;
}

export interface CreateCompanyRequest {
    name: string;
    vatNumber?: string;
    isActive: boolean;
    isSameAddressForBillingAddress: boolean;
    address: Address;
    billingAddress: Address;
    note: string;
    accountingAccountName?: string | null;
    webSite: string;
    email?: string | null;
    contactIds: Array<number>;
    legalEntityAssignedId?: number | null;
    localeIsoCode?: string | null;
    paymentModeId?: number | null;
    directDebit?: DirectDebitMandate;
}

export interface GetCommentsResponse {
    comments: Array<CommentSummary>;
}

export interface CommentSummary {
    id: number;
    content: string;
    createdAt: Date;
    createdById?: number | null;
    createdByFullName?: string | null;
}

export type GetCommentsRequest = Record<string, unknown>;

export enum CommentEntityType {
    Todo = "Todo"
}

export interface CreateCommentResponse {
    id: number;
}

export interface CreateCommentRequest {
    entityId: number;
    entityType: CommentEntityType;
    content: string;
}

export interface GetLiveCallStatisticsResponse {
    callStatistics: QueueLiveStatistics;
}

export interface QueueLiveStatistics {
    lastReset: Date;
    callsLost: number;
    callsAnswered: number;
    totalCallDuration: number;
    callsTotal: number;
    totalWaitingDuration: number;
}

export interface GetCallStatisticsResponse {
    callStatistics: Array<CallStatisticSummary>;
}

export interface CallStatisticSummary {
    id: number;
    date: Date;
    callsTotal: number;
    callsAnswered: number;
    callsLost: number;
    totalCallDurationSeconds: number;
    totalWaitingDurationSeconds: number;
}

export type GetCallStatisticsRequest = Record<string, unknown>;

export interface ResetPasswordResponse {
    message: string;
}

export interface ResetPasswordRequest {
    email: string;
    token: string;
    newPassword: string;
}

export interface RefreshTokenResponse {
    token: string;
    refreshToken: string;
    expiration: Date;
}

export interface RefreshTokenRequest {
    refreshToken: string;
}

export interface LoginResponse {
    token: string;
    refreshToken: string;
    expiration: Date;
    email: string;
}

export interface LoginRequest {
    email: string;
    password: string;
}

export interface LicenceServerTokenResponse {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
}

export interface LicenceServerTokenRequest {
    clientId: string;
    clientSecret: string;
}

export interface ForgotPasswordRequest {
    email: string;
}

export interface TranscribeAudioResponse {
    text: string;
}

export interface TranscribeAudioRequest {
    file: Blob;
}

export interface StartAiConversationResponse {
    conversationId: number;
}

export interface SendAiMessageResponse {
    messages: Array<AiMessageView>;
    disambiguations: Array<NameMention>;
}

export interface AiMessageView {
    id: number;
    role: AiMessageRole;
    content?: string | null;
    action?: ProposedAction;
    actionStatus?: AiActionStatus;
    createdAt: Date;
}

export enum AiMessageRole {
    USER = "USER",
    ASSISTANT = "ASSISTANT"
}

export interface ProposedAction {
    type: AiActionType;
    todoId?: number | null;
    todoTitle?: string | null;
    title?: string | null;
    description?: string | null;
    dueDate?: Date | null;
    priority?: TodoPriorityId;
    statusId?: number | null;
    statusName?: string | null;
    completion?: TodoCompletion;
    estimatedTimeInDays?: number | null;
    isPrivate?: boolean | null;
    assigneeIds: Array<number>;
    assigneeNames: Array<string>;
    subTasks: Array<string>;
    concernId?: number | null;
    concernName?: string | null;
}

export enum AiActionType {
    CREATETODO = "CREATE_TODO",
    CHANGEDESCRIPTION = "CHANGE_DESCRIPTION",
    CHANGETITLE = "CHANGE_TITLE",
    CHANGEDUEDATE = "CHANGE_DUE_DATE",
    CHANGEPRIORITY = "CHANGE_PRIORITY",
    CHANGESTATUS = "CHANGE_STATUS",
    CHANGECOMPLETION = "CHANGE_COMPLETION",
    ADDASSIGNEE = "ADD_ASSIGNEE",
    ADDSUBTASK = "ADD_SUB_TASK"
}

export enum AiActionStatus {
    PENDING = "PENDING",
    CONFIRMED = "CONFIRMED",
    CANCELLED = "CANCELLED"
}

export interface NameMention {
    term: string;
    start: number;
    length: number;
    candidates: Array<NameCandidate>;
    isUnambiguous: boolean;
}

export interface NameCandidate {
    type: AiEntityType;
    id: number;
    fullName: string;
    score: number;
}

export enum AiEntityType {
    PERSON = "PERSON",
    CLIENT = "CLIENT"
}

export interface SendAiMessageRequest {
    text: string;
}

export interface ResolveAiNameRequest {
    term: string;
    entityType: AiEntityType;
    entityId: number;
}

export interface GetCustomerAnalysisResponse {
    analysis: CustomerAnalysisResult;
}

export interface CustomerAnalysisResult {
    summary: Summary;
    recommendation: Recommendation;
}

export interface Summary {
    executiveSummary: string;
    needs: Array<string>;
    risks: Array<string>;
}

export interface Recommendation {
    actions: Array<ActionItem>;
}

export interface ActionItem {
    title: string;
    description: string;
    effort: Severity;
    priority: Severity;
    impact: Severity;
}

export enum Severity {
    Low = "Low",
    Medium = "Medium",
    High = "High"
}

export type GetCustomerAnalysisRequest = Record<string, unknown>;

export interface ConfirmAiActionResponse {
    todoId: number;
}

export interface UpdateActivityTypeRequest {
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
}

export interface GetActivityTypesResponse {
    activityTypes: Array<ActivityTypeSummary>;
}

export interface ActivityTypeSummary {
    id: number;
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
}

export interface GetActivityTypeSelectResponse {
    activityTypes: Array<ActivityTypeSelect>;
}

export type DeleteActivityTypeRequest = Record<string, unknown>;

export interface CreateActivityTypeResponse {
    id: number;
}

export interface CreateActivityTypeRequest {
    nameFr?: string | null;
    nameEn?: string | null;
    nameNl?: string | null;
}

export interface UpdateAccountingPeriodRequest {
    startDate: Date;
    endDate: Date;
    isClosed: boolean;
}

export interface GetAccountingPeriodsResponse {
    accountingPeriods: Array<AccountingPeriodSummary>;
}

export interface AccountingPeriodSummary {
    id: number;
    startDate: Date;
    endDate: Date;
    isClosed: boolean;
}

export interface CreateAccountingPeriodResponse {
    id: number;
}

export interface CreateAccountingPeriodRequest {
    startDate: Date;
    endDate: Date;
    isClosed: boolean;
}

export interface PreviewAccountingExportRequest {
    invoiceIds: Array<number>;
    creditNoteIds: Array<number>;
}

export interface ExportAccountingRequest {
    invoiceIds: Array<number>;
    creditNoteIds: Array<number>;
}

export interface UpdateAccountingAccountRequest {
    name: string;
    account: string;
    accountType?: AccountType;
}

export enum AccountType {
    PRODUCT = "PRODUCT",
    TAX = "TAX",
    TOTAL = "TOTAL"
}

export interface GetAccountingAccountsResponse {
    accountingAccounts: Array<AccountingAccountSummary>;
}

export interface AccountingAccountSummary {
    id: number;
    name: string;
    account: string;
    accountType?: AccountType;
}

export type AccountingAccountFilter = Record<string, unknown>;

export interface GetAccountingAccountByIdResponse {
    accountingAccount: AccountingAccountDetails;
}

export interface AccountingAccountDetails {
    id: number;
    name: string;
    account: string;
    accountType?: AccountType;
}

export type GetAccountingAccountByIdRequest = Record<string, unknown>;
export type DeleteAccountingAccountRequest = Record<string, unknown>;

export interface CreateAccountingAccountResponse {
    id: number;
}

export interface CreateAccountingAccountRequest {
    name: string;
    account: string;
    accountType?: AccountType;
}

/** Request Options for Angular HttpClient requests */
export interface RequestOptions<TResponseType extends 'arraybuffer' | 'blob' | 'json' | 'text'> {
    headers?: HttpHeaders;
    reportProgress?: boolean;
    responseType?: TResponseType;
    withCredentials?: boolean;
    context?: HttpContext;
}
